class VariantPickerDeltas {
  constructor(container) {
    this.container = container;
    this.boundOnChange = this.onChange.bind(this);
  }

  connectedCallback() {
    this.render();
    this.container.addEventListener('change', this.boundOnChange);
  }

  disconnectedCallback() {
    this.container.removeEventListener('change', this.boundOnChange);
  }

  onChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.classList.contains('smart_radio')) return;
    if (!target.hasAttribute('data-price-delta-cents')) return;

    this.render();
  }

  getCurrencyFormatter() {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window?.Shopify?.currency?.active || 'EUR',
    });
  }

  formatMoney(cents) {
    return this.getCurrencyFormatter().format(Number(cents) / 100);
  }

  render() {
    const fieldsets = this.container.querySelectorAll('fieldset');

    for (const fieldset of fieldsets) {
      const radios = fieldset.querySelectorAll('.smart_radio[data-price-delta-cents]');
      if (!radios.length) continue;

      const checkedRadio = fieldset.querySelector('.smart_radio[data-price-delta-cents]:checked');
      const selectedCents = Number(checkedRadio?.dataset.priceDeltaCents || 0);

      for (const radio of radios) {
        const label = radio.nextElementSibling;
        const priceEl = label?.querySelector('[data-option-price-label]');
        if (!priceEl || !(label instanceof HTMLElement)) continue;

        const optionCents = Number(radio.dataset.priceDeltaCents || 0);
        const diffCents = optionCents - selectedCents;
        const isSelected = radio.checked;
        const isNegative = diffCents < 0;

        label.classList.toggle('is-selected', isSelected);
        priceEl.classList.toggle('variant-picker-deltas__option-price--negative', !isSelected && isNegative);

        if (isSelected || diffCents === 0) {
          priceEl.textContent = '';
          continue;
        }

        const sign = diffCents > 0 ? '+' : '-';
        priceEl.textContent = `${sign}${this.formatMoney(Math.abs(diffCents))}`;
      }
    }
  }
}

const variantPickerDeltaInstances = new WeakMap();

function initVariantPickerDeltas(root = document) {
  const containers = root.querySelectorAll('.variant-picker-deltas[data-show-price-deltas]');

  for (const container of containers) {
    if (!(container instanceof HTMLElement)) continue;

    let instance = variantPickerDeltaInstances.get(container);
    if (!instance) {
      instance = new VariantPickerDeltas(container);
      variantPickerDeltaInstances.set(container, instance);
      instance.connectedCallback();
    } else {
      instance.render();
    }
  }
}

window.initVariantPickerDeltas = initVariantPickerDeltas;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVariantPickerDeltas());
} else {
  initVariantPickerDeltas();
}

window.addEventListener('load', () => initVariantPickerDeltas());

document.addEventListener('istorm:variant-picker-deltas-update', () => initVariantPickerDeltas());
